function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8668 1.30698C11.5671 0.89865 12.433 0.89865 13.1333 1.30698L20.9828 5.88349L12 11.1207L3.01733 5.88349L10.8668 1.30698ZM7.48276 5.88349L12 8.51723L16.5173 5.88349L12 3.24974L7.48276 5.88349ZM3 7.88055L10.875 12.3783V23L4.13412 19.15C3.43283 18.7495 3 18.0038 3 17.1962V7.88055ZM13.125 12.3783L21 7.88055V17.1962C21 18.0038 20.5672 18.7495 19.8659 19.15L13.125 23V12.3783ZM18.75 17.1972V11.7557L15.375 13.6833V19.1248L18.75 17.1972Z",
  fill: "#561951"
});

function Svg3DLeftView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DLeftView);
export default __webpack_public_path__ + "static/media/3d_left_view.ac02a73f.svg";
export { ForwardRef as ReactComponent };